<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="point-terms-of-service">
      <Title jpn="Coin 이용 약관" />
      <div class="scroll-container">
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">주식회사 제로 플레이스(이하, “당사”라고 합니다.)가 제공하는
              <a href="https://gtchaxonline.com/" target="_blank" >https://gtchaxonline.com/ </a>
              (이하, “본건 서비스”라고 합니다.)에 있어서 “Coin”(이하로 정의합니다)를 이용함에 있어서, 그 이용에 관한 조건을 정하는 것(이하, “Coin 이용 규약”이라고 합니다.)입니다.</span>
            <span class="text">충분히 Coin 이용 규약의 내용을 확인해 주신 후, Coin의 구입을 검토해 주세요.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">제1조 - 용어의 정의</span>
            <span class="text">본건 규약에 있어서 이하의 각 호의 용어의 의미는, 해당 각 호에 정하는대로로 합니다.</span>
            <span class="text">(1) 「서비스 이용 계약」이란, 본건 서비스의 이용에 관한 계약을 말합니다.</span>
            <span class="text">(2) 「서비스 이용자」란, 당사와 서비스 이용 계약을 체결한 사람을 말합니다.</span>
            <span class="text">(3) 「계정 정보」란, 서비스 이용자가 본건 서비스에 등록한 서비스 이용자에 관한 정보를 말합니다.</span>
            <span class="text">(4) 「Coin」이란, 당사에서만 이용 가능한 통화를 말합니다.</span>
            <span class="text">(5)「이용잔고」란, 서비스 이용자가 보유하고 이용할 수 있는 Coin의 잔고입니다.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">제2조 - 코인</span>
            <span class="text">(1)서비스 이용자는, 당사 소정의 방법에 의해, 당사가 본건 서비스내에서 제시하고 있는 금액으로 본건 서비스내에서 사용 가능한 Coin를 구입할 수 있습니다.또한, 당사는, 서비스 이용자에 대해서, Coin의 구입에 대해 구입 단위, 결제 방법, 이용 기간 그 외의 구입 조건을 마련하는 일이 있어, 설정한 구입 조건 및 지불 가능 금액등은, 운용 서비스 또는</span>
            <span class="text">(2)서비스 이용자가 당사 소정의 방법에 의해 Coin의 구입의 의사 표시를 실시한 시점에서, 해당 Coin의 구입에 관한 서비스 이용자와 당사의 계약은 성립해, 구입에 걸리는 총액이 확정하는 것으로 합니다.</span>
            <span class="text">(3) Coin을 구입하는 서비스 이용자가 미성년자인 경우, 해당 서비스 이용자는 Coin의 구입에 대해 미리 친권자의 동의를 얻어야 합니다.</span>
            <span class="text">(4) 당사는 미성년자가 Coin을 구입한 경우, 친권자가 해당 Coin의 구입에 동의한 것으로 간주합니다.</span>
            <span class="text">(5) 본건 서비스내에 표시되고 있는 서비스 이용자의 이용잔고는, 어카운트 정보에 연계하여 본건 서비스 및 당사가 운영하는 다른 서비스의 제공에 걸리는 전기통신설비에 기록됩니다.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">제3조 - 코인 이용</span>
            <span class="text">(1) Coin은 당사의 상품 구입을 위해 사용할 수 있습니다.</span>
            <span class="text">(2) 서비스 이용자는 Coin 잔액의 범위 내에서 당사가 제공하는 상품을 취득할 수 있습니다.</span>
            <span class="text">(3)서비스 이용자가 당사로부터 상품을 구입할 때에 Coin을 사용한 경우, Coin의 잔고로부터 상품의 대금을 공제함으로써, 해당 대금액의 지불이 있던 것으로 간주됩니다.</span>
            <span class="text">특별한 규정이 없는 경우, 본건 서비스 내에서 당사로부터 서비스 이용자에게 무상으로 부여한 코인으로부터 우선적으로 소비됩니다.</span>
            <span class="text">(4)서비스 이용자는 본건 서비스내에서 Coin의 잔고를 확인할 수 있습니다.또한, 서비스 이용자는 Coin의 증감을 자신의 책임으로 관리해, 확인하는 것으로 합니다.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">제4조 - 코인의 취급</span>
            <span class="text">(1) 당사는 본 서비스에서 이용자가 Coin을 구입한 경우 당사가 캠페인을 실시하는 경우 그 외의 경우에 당사가 정하는 방법에 따라 이용자에게 Coin을 부여합니다.</span>
            <span class="text">(2) Coin의 유효기간은 Coin이 부여된 날부터 6개월로 합니다.</span>
            <span class="text">(3)당사는 이용자가 취득한 Coin에 대하여 법령상 필요한 경우를 제외하고 일체 환불을 하지 않습니다.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">제5조 - 환금행위의 금지 등</span>
            <span class="text">본 서비스내에서 취득한 일체의 콘텐츠에 대해서는, 직접, 제3자에 의한 중개 또는 인터넷 경매 등 그 수단을 불문하고, 매매 그 외, 금전 기타 현실 세계에 있어서의 대가를 수수하는 형태로의 모든 양도, 양수, 대여, 차용 등하는 행위(소위 RMT【리얼마네이트레이드】를 포함합니다만, 이것에 한정되지 않습니다.또, 본 서비스내에 있어서의 유저의 행위에 대해서 금전 그 외, 현실 세계에 있어서의 대가를 수수하는 것도 포함합니다.)를 금지하겠습니다.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">제6조 - 코인의 양도 등</span>
            <span class="text">서비스 이용자는 Coin 및 상품을 제3자에게 양도, 대여, 증여 기타의 이전이나, 질입 기타 담보권의 설정을 할 수 없습니다.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">제7조 -Coin의 구입 및 이용의 정지 등</span>
            <span class="text">서비스 이용자가 다음에 해당하는 경우, 당사는 서비스 이용자에게 당사가 적당하다고 판단하는 조치(Coin의 구입이나 이용의 정지를 포함하지만 이에 한정되지 않음)를 실시할 수 있는 것으로 합니다.</span>
            <span class="text">(1) 부정한 방법으로 Coin이나 상품을 취득, 이용한 경우</span>
            <span class="text">(2) 서비스 이용자가 본건 규약을 위반한 경우</span>
            <span class="text">(3) 그 외, 당사가 서비스 이용자의 본건 서비스의 이용을 부적절하다고 판단한 경우</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">2025년 2월 28일 제정</span>
          </div>
        </ShadowBoxTitleDescription>
      </div>
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import ShadowBoxTitleDescription from '@/components/molecules/ShadowBoxTitleDescription.vue';
import Title from '@/components/molecules/Title02.vue';
import t from '@/plugins/i18n_point_terms_of_service';

export default {
  name: 'TermsOfService',
  mixins: [t],

  components: {
    BaseTemplate,
    ShadowBoxTitleDescription,
    Title,
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
    }),
  },

  created() {
    this.$store.dispatch('user/setCurrentUser', { token: 'yugi' });
  },
};
</script>

<style lang="scss" scoped>
.point-terms-of-service{
  width: 100%;
  max-width: 1000px;
  min-height: 100%;
  padding: 30px 20px 0px;
  margin: 0px auto;
  .point-terms-of-service-title{
    display: flex;
    justify-content: center;
    .text{
      height: 35px;
      font-family: $notoSerif;
      font-size: 24px;
      font-weight: 700;
    }
  }
  .scroll-container{
    width: 100%;
    margin-top: 30px;
    padding-bottom: 50px;
    max-width: 1000px;
    margin-left: auto;
    margin-right: auto;
    .shadow-box-title-description{
      width: 100%;
      .text-container{
        display: flex;
        flex-direction: column;
        padding: 5px 5px 0px 5px;
        .text{
          font-family: $notoSans;
          font-size: 13px;
          line-height: 1.5;
          letter-spacing: 0.03em;
          a {
            color: black!important;
          }
          &.margin-top{
            margin-top: 10px;
          }
          &.one-line-space-top{
            margin-top: 1em;
          }
        }
      }
      & + .shadow-box-title-description{
        margin-top: 40px;
      }
    }
  }
}
</style>
